import { IconCheckLine, Pill } from "@instructure/ui";
import { useTranslation } from "react-i18next";

const JuriedStatusIndicator = ({ termsCompleted, totalTermsPlanned }) => {
  const { t } = useTranslation();

  return (
    <Pill
      color={termsCompleted >= totalTermsPlanned ? "success" : "warning"}
      renderIcon={
        termsCompleted >= totalTermsPlanned ? <IconCheckLine /> : undefined
      }
    >
      {t("results.termsCompleted", {
        termsCompleted: termsCompleted,
        totalTermsPlanned: totalTermsPlanned,
      })}
    </Pill>
  );
};

export default JuriedStatusIndicator;
